<template>
  <vs-button
      @click="click"
      class="m-auto"
      color="light"
      size="small"
  >
    {{ text }}
  </vs-button>
</template>

<script>
export default {
  name: 'CellRendererButton',
  computed: {
    text() {
      return this.params.text || 'Click';
    }
  },
  methods: {
    click() {
      return this.params.onClick(this.params.data);
    }
  },
}
</script>
